import { useEffect, useLayoutEffect, useRef } from 'react'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { CLOSE_ON_ANCESTOR_SCROLL_NEVER } from '../../../../../constants/select'
import { useFloatingSelect } from '../../../../../hooks'

export function useColorPickerFieldPopover({ disabled }) {
  const isOpenRef = useRef(false)

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({
      closeOnAncestorScroll: CLOSE_ON_ANCESTOR_SCROLL_NEVER,
      // The picker has a fixed height; when it doesn't fit below or above, fall
      // back to the side centered on the field (`right`/`left`, not `-start`).
      // `shouldClampHeight: false` keeps it at full height so `flip` sees the
      // real overflow (otherwise `size` would shrink it).
      flipConfig: {
        fallbackPlacements: [
          FLOATING_ELEMENT_PLACEMENT.topStart,
          FLOATING_ELEMENT_PLACEMENT.right,
          FLOATING_ELEMENT_PLACEMENT.left,
        ],
      },
      placement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
      shouldClampHeight: false,
    })

  useLayoutEffect(() => {
    isOpenRef.current = isOpen
  }, [isOpen])

  useEffect(() => {
    if (disabled && isOpen) {
      setOpen(false)
    }
  }, [disabled, isOpen, setOpen])

  function handleClosePopover() {
    setOpen(false)
  }

  function handleOpenPopover() {
    if (!disabled && !isOpenRef.current) {
      setOpen(true)
    }
  }

  return {
    context,
    floatingStyles,
    getFloatingProps,
    handleClosePopover,
    handleOpenPopover,
    isOpen,
    refs,
    setOpen,
  }
}
